exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AutoComplete__suggestionsContainerParent___2PH-x {\n\tposition: relative;\n\tz-index: 2!important;\n}\n\n.AutoComplete__suggestionsContainer___YO7FQ {\n\tbackground-color: #fff;\n\tposition: absolute;\n\tmax-height: 40vh;\n\twidth: 100%;\n\toverflow: auto;\n}\n\n.AutoComplete__suggestionsItem___2J2Oc {\n\theight: 100%!important;\n}\n\n.AutoComplete__theTop___1LkFd {\n\tposition: absolute;\n\ttop: -2rem;\n}\n", ""]);

// exports
exports.locals = {
	"suggestionsContainerParent": "AutoComplete__suggestionsContainerParent___2PH-x",
	"suggestionsContainer": "AutoComplete__suggestionsContainer___YO7FQ",
	"suggestionsItem": "AutoComplete__suggestionsItem___2J2Oc",
	"theTop": "AutoComplete__theTop___1LkFd"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/AutoComplete.icss
// module id = 1444
// module chunks = 0